import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumbs, breadcrumbsClasses, Link, Typography } from '@mui/material';
import { ContainerArbitrator } from '../../ArbitrationObjects/ContainerArbitrator/containerArbitrator';
import { ActionIcons, getIconForType } from '../../Iconography';
/**
 * Renders a Mui {@link Breadcrumbs} component with a custom `onClick` handler
 */
export const ClickableBreadCrumbs = ({ descendingNodes, onClick, selectedNode, fontSize, breadcrumbProps }) => {
    const clone = structuredClone(descendingNodes);
    const leaf = clone.pop();
    if (!leaf)
        return;
    const Icon = getIconForType(leaf.type);
    const baseStyles = {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        paddingInline: 1,
    };
    const selectedStyles = {
        borderRadius: 1,
        backgroundColor: (t) => t.palette.primary.light,
        color: (t) => t.palette.getContrastText(t.palette.primary.light),
    };
    const sx = leaf.sk === selectedNode?.sk ? { ...baseStyles, ...selectedStyles } : baseStyles;
    return (_jsxs(Breadcrumbs, { separator: _jsx(ActionIcons.NavigationTree, {}), sx: { [`& .${breadcrumbsClasses.separator}`]: { marginInline: 0 } }, ...breadcrumbProps, children: [clone.map((node) => {
                const Icon = getIconForType(node.type);
                const sx = node.sk === selectedNode?.sk ? { ...baseStyles, ...selectedStyles } : baseStyles;
                return (_jsxs(Link, { component: "button", underline: "hover", onClick: () => onClick(node), fontSize: fontSize, sx: sx, children: [_jsx(Icon, {}), node.name] }, node.sk));
            }), _jsxs(Typography, { fontSize: fontSize, sx: sx, children: [_jsx(Icon, {}), leaf.name] })] }));
};
/**
 * Renders a Mui {@link Breadcrumbs} component with links that will navigation to each {@link ValidBusinessObject}
 */
export const NavBreadCrumbs = ({ descendingNodes }) => {
    const clone = structuredClone(descendingNodes);
    const leaf = clone.pop();
    return leaf ? (_jsxs(Breadcrumbs, { children: [clone.map((node) => {
                const to = ContainerArbitrator.getCanonicalContainerLinkForObject({
                    vob: node,
                });
                return (_jsx(Link, { underline: 'hover', color: 'inherit', to, children: node.name }, node.name));
            }), _jsx(Typography, { color: "text.primary", children: leaf.name })] })) : null;
};
